export enum FileVersionEnum {
  MARRIED = "MARRIED",
  SINGLE = "SINGLE",
  PJ = "PJ",
  NONE = "NONE",
  PF = "PF"
}

export const FileVersionEnumLabel = new Map<FileVersionEnum, string>([
  [FileVersionEnum.MARRIED, "Casado"],
  [FileVersionEnum.SINGLE, "Solteiro"],
  [FileVersionEnum.PJ, "PJ"],
  [FileVersionEnum.NONE, "Não se aplica"],
  [FileVersionEnum.PF, "PF"]
]);



// WEBPACK FOOTER //
// ./src/services/enum/FileVersionEnum.ts